// extracted by mini-css-extract-plugin
module.exports =  {"job-help-text":"jobs_tab_content__job-help-text___gzWBt","jobHelpText":"jobs_tab_content__job-help-text___gzWBt"};